<template lang="pug">
#rastreabilidade-raizen
    BaseHeaderRastreabilidade(
        titulo='Visualizar  Nota Fiscal',
        :voltarPara='voltarPara',
        :exibeBotao='false'
    )
    .container-view
        .container-info
            h2 Total de notas fiscais cadastradas
            el-row.primeira-linha
                el-col(:span='6')
                    el-row
                        span.label Número da nota fiscal
                    el-row
                        span.info {{ dadosNotaFiscal.numeroNotaFiscal || '--' }}

                el-col(:span='6')
                    el-row
                        span.label Empresa
                    el-row
                        span.info {{ dadosNotaFiscal.empresa || '--' }}

                el-col(:span='6')
                    el-row
                        span.label Material
                    el-row
                        span.info {{ dadosNotaFiscal.materialDescricao || '--' }}

                el-col(:span='6')
                    el-row
                        span.label Quantidade (kg)
                    el-row
                        span.info {{ dadosNotaFiscal.quantidade || '--' }}

            el-row
                el-col(:span='6')
                    el-row
                        span.label Data
                    el-row
                        span.info {{ dadosNotaFiscal.dataEmissao || '--' }}

                el-col(:span='6')
                    el-row
                        span.label Originação
                    el-row
                        span.info {{ dadosNotaFiscal.fazendaCertificada ? 'Bonsucro' : 'Não se aplica' }}

    .container-fazenda
        .container-tabela
            TabelaFazendasNotaFiscal(
                v-loading='buscandoNotaFiscal',
                :dadosTabela='dadosTabela',
                :paginacao='paginacao',
                @atualizar-pagina='atualizarPagina',
                @atualizar-tabela='buscarNotaFiscal',
                @selecionar-territorio='escolherTerritorioMapa'
            )
        .container-mapa
            Mapa(
                idMapa='MapaNotaFiscalRaizen',
                :mapLayersConfigs='camadasMapa',
                :mapConfig='configuracoesMapa',
                :camadaCentralizadaNome='camadaCentralizadaNome'
            )

    .container-view
        span.titulo Histórico de rastreabilidade
        .container-historico
            ItemHistorico(
                :dadosHistorico='dadosHistoricoOrdemCorte',
                etapa='Ordem de corte',
                icone='corte'
            )
            .divider
            ItemHistorico(
                :dadosHistorico='dadosHistoricoNotaPesagem',
                etapa='Nota de pesagem',
                icone='pesagem'
            )
            .divider
            ItemHistorico(
                :dadosHistorico='dadosHistoricoLoteProducao',
                etapa='Lote de produção',
                icone='producao'
            )
            .divider
            ItemHistorico(
                :dadosHistorico='dadosHistoricoNotaFiscal',
                etapa='Nota fiscal',
                icone='nota'
            )
</template>

<script>
import BaseHeaderRastreabilidade from '@/components/rastreabilidadeRaizen/BaseHeaderRastreabilidade';
import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
import TabelaFazendasNotaFiscal from '@/components/rastreabilidadeRaizen/visualizarNotaFiscal/TabelaFazendasNotaFiscal';
import ItemHistorico from '@/components/rastreabilidadeRaizen/visualizarNotaFiscal/ItemHistorico';

import BotoesDeAcoesRastreabilidade from '@/components/rastreabilidadeRaizen/BotoesDeAcoesRastreabilidade';
import BaseCardTotalizadorRastreabilidade from '@/components/rastreabilidadeRaizen/BaseCardTotalizadorRastreabilidade';

import RastreabilidadeDocumentosService from '@/services/RastreabilidadeDocumentosService';

import ModalInsercaoArquivoNotaFiscal from '@/components/rastreabilidadeRaizen/notaFiscal/ModalInsercaoArquivoNotaFiscal.vue';
import RastreabilidadeNotaFiscalService from '@/services/RastreabilidadeNotaFiscalService';

import RastreabilidadeHistoricoRaizen from '@/services/RastreabilidadeHistoricoRaizen';

import TerritorioService from '@/services/TerritorioService';

import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import L from 'leaflet';

const ICONE_PONTO_MAPA = L.icon({
    iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
    iconSize: [18, 26]
});

export default {
    name: 'NotaFiscal',
    props: {
        id: {
            type: String,
            default: () => ''
        }
    },
    components: {
        BaseHeaderRastreabilidade,
        FiltroRastreabilidade,
        TabelaFazendasNotaFiscal,
        ModalInsercaoArquivoNotaFiscal,
        BotoesDeAcoesRastreabilidade,
        BaseCardTotalizadorRastreabilidade,
        ItemHistorico,
        Mapa
    },
    data() {
        return {
            showModalArquivo: false,
            nomeColumn: null,
            voltarPara: true,
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },

            filtros: '',

            idNotaFiscal: null,

            dadosNotaFiscal: {},

            dadosTabela: [],

            dadosHistorico: [],

            dadosHistoricoOrdemCorte: [],

            dadosHistoricoNotaPesagem: [],

            dadosHistoricoLoteProducao: [],

            dadosHistoricoNotaFiscal: [],

            dadosTotalizadores: [],

            buscandoNotaFiscal: true,

            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                diagnostico: true
            },
            territorios: [],
            territoriosBuffer: [],
            camadaCentralizadaNome: null,
            idMunicipio: null
        };
    },
    async created() {
        if (this.$route.params.id) {
            this.idNotaFiscal = this.$route.params.id;
            if (this.idNotaFiscal) {
                this.buscarNotaFiscal(this.idNotaFiscal);
                this.buscarFazendasNotaFiscal(this.idNotaFiscal, 0);
                this.buscarHistoricoPorNotaFiscal(this.idNotaFiscal);
            }
        } else {
            this.$router.push({ name: 'RastreabilidadeRaizen' });
        }
    },
    methods: {
        btnHeaderClicado: function () {},

        async buscarNotaFiscal(id) {
            await RastreabilidadeNotaFiscalService.buscarPorId(id).then(
                ({ data }) => {
                    this.dadosNotaFiscal = data;
                    this.buscandoNotaFiscal = false;
                }
            );
        },

        async findTerritorioById(id) {
            this.territorios = [];
            await TerritorioService.findGeometriaByIdTerritorio(id).then(
                ({ data }) => {
                    this.territorios.push(data);
                }
            );
        },

        async buscarFazendasNotaFiscal(id, pagina) {
            this.buscandoNotaFiscal = true;
            this.paginacao.pagina = pagina;
            this.camadasMapa = [];
            await RastreabilidadeNotaFiscalService.buscarFazendasNotaFiscal(
                id,
                this.paginacao
            )
                .then(({ data }) => {
                    this.dadosTabela = data.itens;

                    this.paginacao = data.paginacao;
                    this.paginacao.pagina += 1;
                    this.buscandoNotaFiscal = false;
                })
                .finally(() => {
                    this.mostrarTerritorios(this.dadosTabela);
                });
        },

        async buscarHistoricoPorNotaFiscal(id) {
            await RastreabilidadeHistoricoRaizen.historicoNotaFiscal(id).then(
                ({ data }) => {
                    this.dadosHistorico = data.itens;
                    this.dadosHistorico.forEach(historico => {
                        if (
                            !this.dadosHistoricoOrdemCorte.some(ordemCorte => {
                                if (
                                    ordemCorte.numero ===
                                    historico.numeroOrdemCorte
                                ) {
                                    return true;
                                } else {
                                    return false;
                                }
                            })
                        ) {
                            this.dadosHistoricoOrdemCorte.push({
                                data: historico.dataCorte,
                                numero: historico.numeroOrdemCorte
                            });
                        }

                        if (
                            !this.dadosHistoricoNotaPesagem.some(
                                notaPesagem => {
                                    if (
                                        notaPesagem.numero ===
                                        historico.notaPesagem
                                    ) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }
                            )
                        ) {
                            this.dadosHistoricoNotaPesagem.push({
                                data: historico.dataPesagem,
                                numero: historico.notaPesagem
                            });
                        }

                        if (
                            !this.dadosHistoricoLoteProducao.some(
                                loteProducao => {
                                    if (
                                        loteProducao.numero ===
                                        historico.numeroLoteProducao
                                    ) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }
                            )
                        ) {
                            this.dadosHistoricoLoteProducao.push({
                                data: historico.dataProducao,
                                numero: historico.numeroLoteProducao
                            });
                        }

                        if (
                            !this.dadosHistoricoNotaFiscal.some(notaFiscal => {
                                if (
                                    notaFiscal.numero ===
                                    historico.numeroNotaFiscal
                                ) {
                                    return true;
                                } else {
                                    return false;
                                }
                            })
                        ) {
                            this.dadosHistoricoNotaFiscal.push({
                                data: historico.dataNotaFiscal,
                                numero: historico.numeroNotaFiscal
                            });
                        }
                    });
                    this.buscandoNotaFiscal = false;
                }
            );
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina - 1;
            this.buscarNotaFiscal(pagina);
        },

        changeShowModalArquivo() {
            this.showModalArquivo = !this.showModalArquivo;
        },

        ordenar(props) {
            this.paginacao.direcao = props.order;
            this.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.paginacao.ordernarPor = null;
            this.buscarNotaFiscal(0);
        },

        async baixarModeloArquivo() {
            await RastreabilidadeDocumentosService.baixarModeloCsv(
                'NOTA_FISCAL'
            );
        },

        async mostrarTerritorios(dadosTerritorioComGeometria) {
            dadosTerritorioComGeometria.forEach(async fazenda => {
                    this.camadasMapa.push({
                        name: 'territorioExibido' + fazenda.idTerritorio,
                        geoJson: fazenda.territorio.geometria,
                        style: getEstiloGeometria('area')
                    });
                    this.territorios.push({
                        id: fazenda.idTerritorio,
                        name: 'territorioExibido' + fazenda.idTerritorio,
                        geoJson: fazenda.territorio.geometria,
                        style: getEstiloGeometria('area')
                    });
            });
        },

        escolherTerritorioMapa(id) {
            this.camadasMapa = [];
            const territorioEscolhido = this.territorios.find(
                territorio => territorio.id === id
            );
            try {
                this.camadasMapa.push({
                    name: 'centroid' + id,
                    geoJson: territorioEscolhido.geoJson,
                    icon: ICONE_PONTO_MAPA,
                    style: getEstiloGeometria('area')
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Ocorreu um erro ao exibir o território'
                });
            }
            this.camadaCentralizadaNome = 'territorioExibido' + id;
        }
    }
};
</script>
<style lang="scss" scoped>
#rastreabilidade-raizen {
    .box-instrucao {
        float: left;
        height: 39px;
        margin-right: 14px;
        color: #3b3b3b;
        max-width: 269px;
        font-size: 13px;

        span {
            padding-left: 3px;
            color: #1989fa;
            text-decoration-line: underline;
        }
    }

    .container-view {
        padding: 20px 35px 0px 20px;
    }

    .titulo {
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: #1e1e1e;
        margin-bottom: 10px;
    }

    .container-info {
        padding: 18px 16px 29px 16px;
        background: #ffffff;
        border-radius: 10px;
        margin-bottom: 19px;

        h2 {
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            color: #3b3b3b;
            padding-bottom: 33px;
        }

        .label {
            font-weight: bold;
            font-size: 14px;
            line-height: 16px;

            color: #00413c;
        }

        .info {
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;

            color: #3b3b3b;
        }

        .primeira-linha {
            padding-bottom: 36px;
        }
    }

    .divider {
        width: 10%;
        border: 1px dashed #00413c;
    }

    .container-historico {
        padding: 60px 98px 70px 98px;
        background: #ffffff;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .container-mapa {
        width: 50%;
        border-radius: 5px;
        z-index: 1;
    }

    .container-fazenda {
        display: flex;
        flex-direction: row;
        overflow-x: hidden;
    }

    .container-tabela {
        width: 48%;
    }
    .lista-area-monitorada__mapa {
        width: 90%;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        margin-bottom: 14px;
        #mapa-listagem-territorio {
            border-radius: 6px;
        }
    }
}
</style>
